export default "__VITE_ASSET__1830b8d6__"